import { LogUser, SessionVrUser } from 'shared/types';

export const getUser = (item: LogUser | SessionVrUser): string => {
  switch (true) {
    case !!item.first_name && !!item.last_name:
      return `${item.last_name}, ${item.first_name}`;
    case !!item.first_name:
      return `${item.first_name}`;
    case !!item.last_name:
      return `${item.last_name}`;
    case !!item.isGuest:
      return 'GUEST, GUEST';
    default:
      return '';
  }
};
